import { Pmdg737MarketingSeo } from "../../../content/templateMarketing/pmdg-737-seo";
import { AircraftAddonTemplate } from "../../../lib/model/addonTemplate";
import pmdg737Image from "../../images/templates/pmdg-737ng.jpg";

export const pmdg737Template: AircraftAddonTemplate = {
  type: "aircraft",
  title: "PMDG 737 NG",
  id: "pmdg-737-ng",
  platforms: ["msfs", "p3d", "fsx"],
  image: pmdg737Image,
  infoMarketingBlurb: Pmdg737MarketingSeo,
  content: [
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation"],
      content: [
        {
          header: "Overhead Panel",
        },
        {
          item: "Battery",
          setting: "On & Guarded",
        },
        {
          item: "Position Light",
          setting: "Steady",
        },
        {
          item: "APU Start Switch",
          setting: "Start",
        },
        {
          item: "IRS Mode Selectors",
          setting: "NAV",
        },
        {
          item: "Yaw Damper",
          setting: "On",
        },
        {
          item: "Fuel System",
          setting: "Check & Set",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Arm & Guarded",
        },
        {
          item: "Passenger Signs",
          setting: "On",
        },
        {
          item: "Window Heat",
          setting: "On",
        },
        {
          item: "Hydraulic Pumps A & B",
          setting: "All On",
        },
        {
          item: "Air Condition System",
          setting: "Check & Set",
        },
        {
          item: "Pressurization SYstem",
          setting: "Set",
        },
        {
          header: "Glare Shield",
        },
        {
          item: "EFIS Control Panel",
          setting: "Set",
        },
        {
          item: "Mode Control Panel",
          setting: "Set",
        },
        {
          header: "Main Panel & Center Pedestal",
        },
        {
          item: "Auto Brakes",
          setting: "RTO",
        },
        {
          item: "Parking Brake",
          setting: "Set",
        },
        {
          item: "COM, NAV, ADF Radios",
          setting: "Set",
        },
        {
          item: "Transponder",
          setting: "Set & Stby",
        },
      ],
    },
    {
      title: "Pre-Flight Checklist",
      roles: ["beforeFlightStart", "beforePushback", "beforeEngineStart"],
      content: [
        {
          item: "Flight Deck Door",
          setting: "Closed & Locked",
        },
        {
          item: "Fuel",
          setting: "____ lbs/kgs, Pumps On",
        },
        {
          item: "Passenger Signs",
          setting: "Set",
        },
        {
          item: "Windows",
          setting: "Locked",
        },
        {
          item: "MCP",
          setting: "V2 ____, Heading ____, Altitude ____",
        },
        {
          item: "Takeoff Speeds",
          setting: "Set",
        },
        {
          item: "CDU Preflight",
          setting: "Completed",
        },
        {
          item: "Rudder & Aileron Trim",
          setting: "Free and Zero",
        },
        {
          item: "Taxi & Takeoff Briefing",
          setting: "Completed",
        },
        {
          item: "Anti-collision Light",
          setting: "On",
        },
      ],
    },
    {
      title: "Engine Start",
      roles: ["engineStart"],
      content: [
        {
          item: "Throttles",
          setting: "Verify Idle",
        },
        {
          item: "Engine 2 Start Selector",
          setting: "GRD",
        },
        {
          item: "Engine 2 Start Lever",
          setting: "IDLE / RUN",
        },
        {
          item: "Engine 2 Start Selector",
          setting: "Verify Off/Auto",
        },
        {
          item: "Engine 1 Start Selector",
          setting: "GRD",
        },
        {
          item: "Engine 1 Start Lever",
          setting: "IDLE / RUN",
        },
        {
          item: "Engine 1 Start Selector",
          setting: "Verify Off/Auto",
        },
      ],
    },
    {
      title: "After Start",
      roles: ["afterEngineStart", "beforeTaxi", "taxi"],
      content: [
        {
          item: "ENG Generators",
          setting: "Both On",
        },
        {
          item: "Probe Heat Switches",
          setting: "AUTO / On",
        },
        {
          item: "Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Air Condition/Pressurization",
          setting: "Auto",
        },
        {
          item: "APU",
          setting: "As Required / Off",
        },
        {
          item: "Flight Controls",
          setting: "Free & Full Movement",
        },
        {
          item: "Overhead Panel",
          setting: "Check",
        },
        {
          item: "Recall Button",
          setting: "Press & Checked",
        },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "takeoff"],
      content: [
        {
          item: "Flaps",
          setting: "Set for TO",
        },
        {
          item: "Stabilizer Trim",
          setting: "Set for TO",
        },
        {
          item: "MCP",
          setting: "Set",
        },
        {
          item: "Recall Button",
          setting: "Press & Checked",
        },
        {
          item: "ENG Start Selectors",
          setting: "Cont / Auto",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Strobe Lights",
          setting: "On",
        },
        {
          item: "Autothrottle",
          setting: "Arm",
        },
        {
          item: "Transponder",
          setting: "TA/RA",
        },
        {
          item: "Weather Radar",
          setting: "On",
        },
        {
          item: "Speedbrakes/Spoilers",
          setting: "Not Armed",
        },
        {
          item: "TO Config Test",
          setting: "Checked",
        },
      ],
    },
    {
      title: "Climb",
      roles: ["climbOut"],
      content: [
        {
          item: "Landing Gear",
          setting: "UP",
        },
        {
          item: "Landing Gear Lever",
          setting: "Neutral",
        },
        {
          item: "Flaps",
          setting: "Up",
        },
        {
          item: "Packs",
          setting: "Auto",
        },
        {
          item: "Pressurization",
          setting: "Check",
        },
        {
          item: "Anti-Ice",
          setting: "As Required",
        },
        {
          item: "ENG Start Selectors",
          setting: "As Required",
        },
        {
          item: "Center Fuel Tanks",
          setting: "As Required",
        },
        {
          item: "Taxi & Runway Turnoff Lights",
          setting: "Off",
        },
        {
          header: "Passing 10,000 ft",
        },
        {
          item: "Landing Lights",
          setting: "Off",
        },
        {
          item: "Logo Lights",
          setting: "Off",
        },
        {
          item: "Passenger Signs",
          setting: "As Required",
        },
        {
          header: "Passing Transition Altitude",
        },
        {
          item: "Altimiters",
          setting: "STD",
        },
      ],
    },
    "page-break",
    {
      title: "Cruise",
      roles: ["cruise"],
      content: [
        {
          item: "Pressurization",
          setting: "Check",
        },
        {
          item: "Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Passenger Signs",
          setting: "As Required",
        },
        {
          item: "Center Fuel Tanks",
          setting: "Off",
        },
        {
          item: "Crossfeed",
          setting: "As Required",
        },
      ],
    },
    {
      title: "Descent",
      roles: ["beforeDescent"],
      content: [
        {
          item: "Altitude Preselct",
          setting: "Check",
        },
        {
          item: "Pressurization",
          setting: "Check",
        },
        {
          item: "Landing Data",
          setting: "Check",
        },
        {
          item: "ILS Frequency",
          setting: "Set",
        },
        {
          item: "Autobrake",
          setting: "Set",
        },
        {
          item: "Radio/Baro Minimums",
          setting: "Set",
        },
        {
          item: "NAV & ADF Radios",
          setting: "Check",
        },
        {
          item: "Anti-Ice",
          setting: "As Required",
        },
        {
          item: "Center Fuel Tanks",
          setting: "Off",
        },
        {
          item: "Crossfeed",
          setting: "Check",
        },
        {
          item: "ENG Start Selectors",
          setting: "AUTO / CONT",
        },
        {
          header: "Passing Transition Altitue",
        },
        {
          item: "Altimeters",
          setting: "Local",
        },
        {
          header: "Passing 10,000 ft",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "Passenger Signs",
          setting: "As Required",
        },
      ],
    },
    {
      title: "Approach",
      roles: ["approach", "landing"],
      content: [
        {
          item: "Altimeters",
          setting: "Verify Local",
        },
        {
          item: "Autobrake",
          setting: "Set",
        },
        {
          item: "Landing Lights",
          setting: "On",
        },
        {
          item: "ENG Start Selectors",
          setting: "CONT / AUTO",
        },
        {
          item: "ILS Frequency",
          setting: "SET",
        },
      ],
    },
    {
      title: "After Landing",
      roles: ["afterLanding"],
      content: [
        {
          item: "Taxi Lights",
          setting: "On",
        },
        {
          item: "Runway Turnoff Light",
          setting: "As Required",
        },
        {
          item: "Landing LIghts",
          setting: "Off",
        },
        {
          item: "Strobe Lights",
          setting: "Off",
        },
        {
          item: "APU",
          setting: "Start",
        },
        {
          item: "Probe Heat Switches",
          setting: "Off / Auto",
        },
        {
          item: "ENG Start Selectors",
          setting: "Off / Auto",
        },
        {
          item: "Flight Director",
          setting: "Off",
        },
        {
          item: "Speed Brake Lever",
          setting: "Down",
        },
        {
          item: "Flaps",
          setting: "Up",
        },
        {
          item: "Weather Radar",
          setting: "Off",
        },
        {
          item: "Transponder",
          setting: "Stby",
        },
        {
          item: "APU Gen",
          setting: "On",
        },
      ],
    },
    {
      title: "Shutdown",
      roles: ["shutdown", "parking"],
      content: [
        {
          item: "Parking Brake",
          setting: "Set",
        },
        {
          item: "Electrical",
          setting: "APU / EXT",
        },
        {
          item: "Start Levers",
          setting: "Cutoff",
        },
        {
          item: "Autobrake",
          setting: "Off",
        },
        {
          item: "Window Heat Switches",
          setting: "Off",
        },
        {
          item: "Anti-Ice",
          setting: "Off",
        },
        {
          item: "Electric Hydraulic Pumps",
          setting: "Off",
        },
        {
          item: "Passenger Signs",
          setting: "Off",
        },
        {
          item: "Anti Collision Switch",
          setting: "Off",
        },
        {
          item: "Taxi & Runway Turnoff Lights",
          setting: "Off",
        },
        {
          item: "Fuel Pump Switches",
          setting: "Off",
        },
        {
          item: "Air Conditioning System",
          setting: "Check",
        },
      ],
    },
    {
      title: "Securing",
      roles: ["securing"],
      content: [
        {
          item: "IRS Selectors",
          setting: "Off",
        },
        {
          item: "Emergency Exit Lights",
          setting: "Off",
        },
        {
          item: "Air Condition Packs",
          setting: "Off",
        },
        {
          item: "APU & Ext Power",
          setting: "Off",
        },
        {
          item: "Battery",
          setting: "Off",
        },
      ],
    },
  ],
};
